const footerLinks = {
  termsOfUse: 'https://www.sittercity.com/terms',
  privacy: 'https://www.sittercity.com/privacy',
  accessibility: 'https://support.sittercity.com/hc/en-us/articles/6042195902619-Accessibility-Information',
  trustAndSafety: 'https://www.sittercity.com/trust-and-safety',
  communityInclusion: 'https://support.sittercity.com/hc/en-us/articles/360018694973-Sittercity-Community-Inclusion-Policy',
  doNotSellMyPersonalInformation: 'https://www.sittercity.com/do-not-sell-my-personal-information',
  help: 'https://support.sittercity.com/hc/en-us',
};

export default footerLinks;
